import clsx from 'clsx'
import cartwheelIconSrc from './assets/cartwheel.svg'
import healthieIconSrc from './assets/healthie.svg'
import kustomerIconSrc from './assets/kustomer.svg'
import uphealIconSrc from './assets/upheal.svg'
import { Tooltip } from './tooltip'

export type ClientLinkDestination = 'cartwheel' | 'healthie' | 'kustomer'

export interface ClientLinksProps {
  cartwheelHref?: string | null
  healthieHref?: string | null
  kustomerHref?: string | null
  className?: string
  onResourceClick?: (destination: ClientLinkDestination) => void
}

export function ClientLinks({
  cartwheelHref,
  healthieHref,
  kustomerHref,
  className,
  onResourceClick,
}: ClientLinksProps) {
  return (
    <div className={clsx('@container flex items-center gap-2', className)}>
      <ResourceLink
        href={cartwheelHref}
        label="Cartwheel"
        icon={<CartwheelIcon />}
        onClick={() => onResourceClick?.('cartwheel')}
      />
      <ResourceLink
        href={healthieHref}
        label="Healthie"
        icon={<HealthieIcon />}
        onClick={() => onResourceClick?.('healthie')}
      />
      <ResourceLink
        href={kustomerHref}
        label="Kustomer"
        icon={<KustomerIcon />}
        onClick={() => onResourceClick?.('kustomer')}
      />
    </div>
  )
}

function ResourceLink({
  href,
  label,
  icon,
  onClick,
}: {
  href: string | null | undefined
  label: string
  icon: React.ReactNode
  onClick: () => void
}) {
  if (!href) return null

  const link = (
    <a
      className="flex size-8 items-center justify-center rounded text-sm font-semibold leading-[1.5] text-forest hover:bg-sand focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-forest @xs:size-auto @xs:gap-1 @xs:rounded-none @xs:hover:bg-transparent @xs:hover:underline"
      href={href}
      target="_blank"
      rel="noreferrer"
      onClick={onClick}
    >
      {icon}
      <span className="sr-only">{label}</span>
      <span className="hidden @xs:inline" aria-hidden="true">
        {label}
      </span>
    </a>
  )

  return <Tooltip text={label} render={link} />
}

export function CartwheelIcon() {
  return <img alt="" className="size-4 shrink-0" src={cartwheelIconSrc} aria-hidden="true" />
}

export function HealthieIcon() {
  return (
    <img alt="" className="h-[13px] w-[18px] shrink-0" src={healthieIconSrc} aria-hidden="true" />
  )
}

function KustomerIcon() {
  return <img alt="" className="size-4 shrink-0" src={kustomerIconSrc} aria-hidden="true" />
}

export function UphealIcon() {
  return (
    <img alt="" className="h-[12px] w-[16px] shrink-0" src={uphealIconSrc} aria-hidden="true" />
  )
}
